const restaurant = {
  restaurant: "ร้านอาหาร", // translated
  restaurants: "ร้านอาหาร", // translated
  category: "หมวดหมู่", // translated
  score: "คะแนน", // translated
  priceQuartile: "ควอไทล์ราคา", // translated
  scoreLowestFirst: "คะแนน (ต่ำสุดก่อน)", // translated
  scoreHighestFirst: "คะแนน (สูงสุดก่อน)", // translated
  priceLowestFirst: "ราคา (ต่ำสุดก่อน)", // translated
  priceHighestFirst: "ราคา (สูงสุดก่อน)", // translated
  allPrices: "ราคาทั้งหมด", // translated
  reserve: "จอง", // translated
  dining: "การรับประทานอาหาร", // translated
};


export default restaurant;
